















































































































































































































































































































import {Component, Emit, Prop, Vue} from 'vue-property-decorator';
import html2canvas from 'html2canvas';
import {CikeUtils} from '@/utils';
import moment, {Moment} from 'moment';
import {
  FilterOptionMaps,
  FilterValues,
  SHOW_KEYS,
  ShowOptionMaps,
  TemplateOptions
} from '@/views/media/course/components/course-filter';
import {STORE_ID} from '@/maps/enum/store';
import {COURSE_ID, COURSE_TYPE_NAMES, COURSE_TYPES} from '@/maps/enum/course';


/**检索类型*/
enum FILTER_SEARCH_TYPES {
  COURSE = 'course',
  STORE = 'store',
  TEACHER = 'teacher',
  ROOM = 'room',
  WEEK = 'week',
  SEMESTER = 'semester'
}


const Tactics = {
  filterOptionDefault: function(): FilterOptionMaps {
    let course: FilterOptionMaps['course'] = [];
    let type: FilterOptionMaps['type'] = [];
    for (const course_id in COURSE_ID) {
      if (CikeUtils.isNumber(+course_id)) {
        course.push({
          id: +course_id,
          name: COURSE_ID[course_id]
        });
      }

    }
    for (const type_id in COURSE_TYPES) {
      if (CikeUtils.isNumber(+type_id)) {
        type.push({
          id: +type_id,
          // @ts-ignore
          name: COURSE_TYPE_NAMES[COURSE_TYPES[type_id]]
        });
      }
    }
    return {
      room: [],
      course: course,
      semester: [],
      type: type,
      store: [
        {id: STORE_ID.ZHU_JIANG_XIN_CHENG, name: '珠江新城店', room: [{id: 24, name: '教室A'}, {id: 25, name: '教室B'}]},
        {id: STORE_ID.TI_YU_XI_LU, name: '体育西路店', room: [{id: 32, name: '教室A'}, {id: 33, name: '教室B'}]},
        {id: STORE_ID.HUA_SHI, name: '华师店', room: [{id: 28, name: '教室A'}, {id: 29, name: '教室B'}]},
        {id: STORE_ID.KE_CUN, name: '客村店', room: [{id: 22, name: '教室A'}, {id: 23, name: '教室B'}]},
        {id: STORE_ID.GUANG_ZHOU_DONG_ZHAN, name: '广州东站店', room: [{id: 20, name: '教室A'}]},
        {id: STORE_ID.HANG_XI_CHANG_LONG, name: '汉溪长隆店', room: [{id: 34, name: '教室A'}, {id: 35, name: '教室B'}]},
        {id: STORE_ID.TAO_JING, name: '淘金店', room: [{id: 26, name: '教室A'}, {id: 27, name: '教室B'}]},
        {id: STORE_ID.YUE_XIU_GONG_YUAN, name: '越秀公园店', room: [{id: 38, name: '教室A'}, {id: 39, name: '教室B'}]},
      ],
      week: [
        {id: 1, name: '周一'},
        {id: 2, name: '周二'},
        {id: 3, name: '周三'},
        {id: 4, name: '周四'},
        {id: 5, name: '周五'},
        {id: 6, name: '周六'},
        {id: 0, name: '周日'}
      ],
      teacher: [],
      isPut: true
    };
  }
};


const filterDefault = {
  type_list: [
    {id: COURSE_TYPES.TYPE_TRAINING_FIVE, name: '五天集训'},
    {id: COURSE_TYPES.TYPE_TRAINING, name: '3天集训'}
  ]
};

@Component
export default class CourseFilter extends Vue {
  /**下载锁*/
  @Prop()
  private lock: boolean | undefined;
  /**node*/
  @Prop()
  private nodeMaps: Array<string> | undefined;
  /**筛选数据*/
  @Prop()
  private optionMap?: FilterOptionMaps | undefined;
  /**内容编辑*/
  @Prop()
  private contentOptionMap: TemplateOptions | undefined;
  @Prop()
  private showOptionMap: ShowOptionMaps | undefined;
  /**抛出筛选值*/
  private filterValues: FilterValues = {
    course: [],
    teacher: [],
    store: [],
    type: [],
    room: [],
    semester: [],
    isPut: true,
    week: [],
  };


  /**data*/
  private data: Array<any> = [];
  /**data*/
  private imgSrc: string | undefined;
  /**规则内容*/
  private tips_data: string | undefined;
  /**tips编辑定位*/
  private tips_index: number | undefined;

  created() {
    this.optionMap = Tactics.filterOptionDefault();
  }

  /**标题修改*/
  @Emit('titleInput')
  public titleInput(value: any) {
    return Promise.resolve(this.contentOptionMap?.title);
  }

  /**客服电话*/
  @Emit('coursePhone')
  public phoneInput(value: any) {
    return Promise.resolve(this.contentOptionMap?.phone_number);
  }


  @Emit('showSwitch')
  public showChange(e: boolean, type: SHOW_KEYS) {
    switch (type) {
      case 'footer':
        return Promise.resolve(Object.assign(this.showOptionMap, {footer: e}));
      case 'store':
        return Promise.resolve(Object.assign(this.showOptionMap, {store: e}));
      case 'qrcode':
        return Promise.resolve(Object.assign(this.showOptionMap, {qrcode: e}));
      case 'tips':
        return Promise.resolve(Object.assign(this.showOptionMap, {tips: e}));
    }
  }

  /**星期提示选择*/
  @Emit('weekLabelChange')
  public weekLabelChange(e: 'day' | 'time') {
    this.$set(this.contentOptionMap!, 'week_label', e);
    return Promise.resolve(e);
  }


  /**更新时间选择*/
  @Emit('updateChange')
  public updateChange(value: Moment) {
    return Promise.resolve(value.format('YYYY.MM.DD'));
  }

  public courseChange(value: any) {
  }

  /**课表类型*/
  public typeChange(value: Array<number>) {
    this.$set(this.filterValues, 'type', value);
  }

  /**时间选择*/
  @Emit('courseDate')
  public dateChange(value: Moment) {
    let end = moment(value).add(6, 'd').format('MM.DD');
    this.contentOptionMap!.title = `(${value.format('YYYY.MM.DD')} - ${end})`;
    return Promise.resolve(value.format('YYYY-MM-DD'));
  }

  /**生成课表*/
  @Emit('courseLoad')
  public courseLoad(): Promise<FilterValues> {
    return Promise.resolve(this.filterValues);
  }


  @Emit('saveTips')
  /**提示修改*/
  public saveTips() {
    this.$set(this.contentOptionMap!.tips, this.tips_index!, this.tips_data);
    return Promise.resolve(this.contentOptionMap?.tips);
  }

  @Emit('delTips')
  /**删除提示*/
  public delTips(index: number) {
    return Promise.resolve(index);
  }

  /**退出编辑*/
  @Emit('hideFilter')
  public exitEdit() {
  }

  /**温馨提示修改*/
  public editTips(index: number) {
    this.tips_index = index;
    this.tips_data = this.contentOptionMap?.tips[index];
    this.$forceUpdate();
  }

  /**上线转换*/
  public filterPutChange(put: any) {
    this.optionMap!.isPut = put;
    this.filterValues.isPut = put;
  }


  /**开始打印*/
  public printStart() {
    html2canvas(document.getElementById('course-canvas')!, {
      backgroundColor: 'white',
      allowTaint: true,
      height: document.getElementById('course-canvas')!.clientHeight,
      useCORS: true
    }).then(canvas => {
      let a = document.createElement('a');
      let event = new MouseEvent('click');
      a.download = `${this.contentOptionMap?.title}.jpeg`;
      a.href = canvas.toDataURL();
      a.dispatchEvent(event);
    });
  }

  /**检索*/
  public handleSearch($event: any, type: FILTER_SEARCH_TYPES) {
    let searchList = [];
    switch (type) {
      case FILTER_SEARCH_TYPES.COURSE:
        break;
      case FILTER_SEARCH_TYPES.STORE:
      case FILTER_SEARCH_TYPES.TEACHER:
    }
  }

  /**门店选中*/
  public storeChange(value: Array<number>) {
    //清空选项
    document.getElementById('room')!.querySelector('input')!.dispatchEvent(new Event('blur'));
    this.$set(this, 'filterValues', Object.assign(this.filterValues, {room: []}));
    this.$set(this, 'optionMap', Object.assign(this.optionMap, {room: []}));
    this.$nextTick(() => {
      let roomAry: Array<any> = [];
      value.forEach(store_id => {
        let active = filterDefault.store_list.find(store => store.id == store_id);
        let room_list = active!.room.map(room => {
          return Object.assign(JSON.parse(JSON.stringify(room)), {name: `${active?.name}-${room.name}`});
        });
        roomAry = roomAry.concat(room_list);
      });
      this.optionMap!.room = roomAry;
      this.lock = true;
    });
  }

  /**get 获取课程列表*/
  public get courseOption() {
    return this.optionMap?.course;
  }


  public addTips() {
    this.contentOptionMap?.tips.push('请输入提示内容');
  }

  /**get 获取教师列表*/
  public get teacherOption() {
    return this.optionMap?.teacher;
  }

  /**get 类型列表*/
  public get typeOption() {
    return this.optionMap?.type;
  }

  /**get 获取周几列表*/
  public get storeOption() {
    return this.optionMap?.store;
  }

  /**get 获取周几列表*/
  public get semesterOption() {
    return this.optionMap?.semester;
  }

  /**get tips*/
  public get tipsScope() {
    return this.contentOptionMap?.tips;
  }

  /**课程筛选*/
  public get courseIdList(): Array<{ key: string; value: number; }> {
    return [];
  }

  /**教室禁用,选中门店后才能选则,默认全部*/
  public get filterRoomDisabled(): boolean {
    return this.filterValues.store.length == 0;
  }


}
